"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onTabPanelKeyDown = exports.onTabKeyDown = exports.onTabClick = exports.getTabPanelIndexById = exports.getPreviousTab = exports.getNextTab = exports.getLastTab = exports.getFirstTab = exports.getDTabPanelFromId = exports.getDTabFromId = void 0;

const rotateArray = (arr, startIndex) => arr.slice(startIndex).concat(arr.slice(0, startIndex));

const getPanelID = tab => tab ? tab.props.tabPanelId : null;

const getFirstTab = tabs => getPanelID(tabs.find(tab => !tab.props.disabled));

exports.getFirstTab = getFirstTab;

const getLastTab = tabs => getPanelID([...tabs].reverse().find(tab => !tab.props.disabled));

exports.getLastTab = getLastTab;

const getTabPanelIndexById = (tabs, tabId) => tabs.findIndex(_ref => {
  let {
    props: {
      tabPanelId
    }
  } = _ref;
  return tabPanelId === tabId;
});

exports.getTabPanelIndexById = getTabPanelIndexById;

const getPreviousTab = (tabs, tabId) => getPanelID(rotateArray(tabs, getTabPanelIndexById(tabs, tabId)).reverse().find(tab => !tab.props.disabled));

exports.getPreviousTab = getPreviousTab;

const getNextTab = (tabs, tabId) => getPanelID(rotateArray(tabs, getTabPanelIndexById(tabs, tabId) + 1).find(tab => !tab.props.disabled));

exports.getNextTab = getNextTab;
const keys = {
  end: 'End',
  home: 'Home',
  left: 'ArrowLeft',
  up: 'ArrowUp',
  right: 'ArrowRight',
  down: 'ArrowDown',
  delete: 'Delete',
  tab: 'Tab'
};

const onTabKeyDown = (e, activeTab, setActiveTab, tabs, root) => {
  const key = e.key;
  const rtl = !!document.querySelector('[dir="rtl"]');
  if (rtl) tabs = [...tabs].reverse();

  if (key === keys.end || key === keys.home || key === keys.right || key === keys.left || key === keys.up || key === keys.down) {
    e.preventDefault();
  }

  let nextTab = activeTab;

  if (key === keys.end) {
    nextTab = getLastTab(tabs);
  } else if (key === keys.home) {
    nextTab = getFirstTab(tabs);
  } else if (key === keys.left) {
    nextTab = getPreviousTab(tabs, activeTab);
  } else if (key === keys.right) {
    nextTab = getNextTab(tabs, activeTab);
  }

  const nextTabDOM = getDTabFromId(nextTab, root);

  if (!e.shiftKey && key === keys.tab) {
    e.preventDefault();
    const activeTabPanel = getDTabPanelFromId(activeTab, root);
    activeTabPanel.focus();
  } else if (nextTab !== activeTab && nextTabDOM) {
    setActiveTab(nextTab);
    nextTabDOM.focus({
      preventScroll: true
    });
  }
};

exports.onTabKeyDown = onTabKeyDown;

const onTabClick = (e, setActiveTab, tabPanelId) => {
  setActiveTab(tabPanelId);
};

exports.onTabClick = onTabClick;

const onTabPanelKeyDown = (e, activeTab, root) => {
  const activePanel = getDTabPanelFromId(activeTab, root);

  if (e.key === 'Tab' && e.shiftKey && document.activeElement === activePanel) {
    e.preventDefault();
    const activeDTab = getDTabFromId(activeTab, root);
    if (activeDTab) activeDTab.focus();
  }
};

exports.onTabPanelKeyDown = onTabPanelKeyDown;

const getDTabFromId = function (id) {
  let root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return root.querySelector(`[aria-controls="${id}"]`);
};

exports.getDTabFromId = getDTabFromId;

const getDTabPanelFromId = function (id) {
  let root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return root.querySelector(`#${id}`);
};

exports.getDTabPanelFromId = getDTabPanelFromId;